import React, { useCallback, useEffect, useRef, useState } from "react";

import axios from "axios";
import { useTranslation } from 'react-i18next';
import {
  TextField,
  Button,
  Grid,

  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Collapse,
  IconButton,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import MainCard from "../../ui-component/cards/MainCard";
import HomePageService from "../../services/HomePage";
import { getUseOldGeocodingApi, setUseOldGeocodingApi } from "../../services/HomePage";
//import MapComponent from "./LiveMap";
import GoogleMapComponent from "./GoogleMapComponent";
import OpenStreetMapComponent from "./OpenStreetMapComponent";
import { none } from "ol/centerconstraint";
import SearchIcon from "@mui/icons-material/Search"; // Import the search icon
import FilterListIcon from "@mui/icons-material/FilterList";
import { keyMapping, iconData, iconStyles, fullText, isoDatePattern } from "../../store/constant";
import { formatDateTime, getRole } from "../../helper"
import CircularProgress from '@mui/material/CircularProgress';
import "./tabstyle.css";

const vehicleIconContext = require.context('../../assets/images', true, /\.png$/);

const LiveTracking = () => {
  const { t } = useTranslation();
  const [load, setLoad] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");

  const normalizeCategoryKey = useCallback((value) => {
    return String(value || '').trim().toLowerCase();
  }, []);

  const [vehicleNo, setVehicleNo] = useState("");
  const [imeiNo, setImeiNo] = useState("");
  const [owner, setOwner] = useState("");
  const [poi, setPoi] = useState("");
  const [roads, setRoads] = useState("");
  const [polygon, setPolygon] = useState("");
  const [category, setCategory] = useState("");
  const [categoryMaxSpeed, setCategoryMaxSpeed] = useState("");
  const [categorySpeedMap, setCategorySpeedMap] = useState({});
  const [make, setMake] = useState("");
  const [district, setDistrict] = useState("");
  const [speedLimit, setSpeedLimit] = useState("");
  const [inRange, setInRange] = useState(false);
  const [poiAsPolygon, setPoiAsPolygon] = useState(false);
  const userRole = getRole();
  const [typeFilter, setTypeFilter] = useState("default");
  const [tableDataTop, setTableDataTop] = useState([]); // Data for the scrollable table
  const [selectedId, setSelectedId] = useState(null); // Track the selected button ID
  const [filteredData, setFilteredData] = useState([]); // Data for the bottom table
  const [focusedEntry, setFocusedEntry] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [markerLabelMode, setMarkerLabelMode] = useState('vehicle');
  const [policeLocations, setPoliceLocations] = useState([]);
  const [incidentData, setIncidentData] = useState([]);
  const [useNmrLocation, setUseNmrLocation] = useState(false);
  const [useOldGeocodingApi, setUseOldGeocodingApiState] = useState(getUseOldGeocodingApi());
  const [nmrArea, setNmrArea] = useState(null);
  const [reverseGeocodeCache, setReverseGeocodeCache] = useState({});
  const fullDataRef = useRef([]); // processed items we've appended so far
  const fullRawRef = useRef([]);  // raw items from API (unprocessed)
  const listContainerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(0);
  // NEW STATE
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();
  const debounceRef = useRef();
  const [manualSearch, setManualSearch] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const controllerRef = useRef(null);
  const [mapType, setMapType] = useState("osm"); // default to google, can be switched to "osm"
  const [mapMode, setMapMode] = useState("roadmap");
  const [viewAllVehicles, setViewAllVehicles] = useState(false);
  // Header tab filter: 'all' | 'ontrip' | 'stopped'
  const [tripFilter, setTripFilter] = useState("all");

  const isSuperAdmin = userRole === "superadmin";

  // FETCH VEHICLE LIST (Debounced)
  const fetchVehicleDropdown = async (value = "", showAll = false) => {
    try {
      // CANCEL PREVIOUS REQUEST
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      controllerRef.current = new AbortController();
      const res = await HomePageService.getVehicleList({
        vehicle_no: showAll ? "" : value.toUpperCase()
      },
        {
          signal: controllerRef.current.signal
        });

      const list =
        res?.data?.data ||
        res?.data?.results ||
        res?.data ||
        [];

      // VIEW ALL VEHICLES MODE
      if (showAll) {
        setVehicleOptions(list);
        setDropdownOpen(list.length > 0);
        return;
      }
      //  FILTER
      const filtered = list.filter((item) => {
        const val =
          typeof item === "string"
            ? item.toUpperCase()
            : (item.vehicle_registration_number || item.regno || "").toUpperCase();

        return val.includes(value.toUpperCase());
      });

      //  EXACT MATCH → AUTO SELECT
      const exactMatch = filtered.find(
        (item) =>
          (typeof item === "string"
            ? item
            : item.vehicle_registration_number || item.regno
          ).toUpperCase() === value.toUpperCase()
      );

      if (exactMatch) {
        // Pass the full matched item (not just the label) so that when the
        // vehicle list API returns an imei alongside the registration
        // number, we can look the vehicle up by imei - this is what the
        // gps_track_data_api endpoint reliably filters on. Filtering purely
        // by regno was the root cause of the marker not showing up after
        // selecting a vehicle (regno matches on the backend can silently
        // fail/return nothing while imei matches always work).
        handleSelectVehicle(exactMatch);
        return;
      }

      // LIMIT RESULTS
      setVehicleOptions(filtered.slice(0, 8));
      setDropdownOpen(filtered.length > 0);

    } catch (err) {
      console.error("Dropdown API error", err);
    }
  };

  // HANDLE INPUT
  const handleVehicleSearch = (e) => {
    setManualSearch(true);
    const value = e.target.value.toUpperCase();
    setVehicleNo(value);

    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      if (value.length >= 4) {
        fetchVehicleDropdown(value);
      } else {
        setDropdownOpen(false);
        setVehicleOptions([]);
      }
    }, 800);
  };

  // SELECT VEHICLE
  // Accepts either a plain registration-number string (legacy call sites)
  // or the full vehicle object returned by the vehicle-list API. When an
  // imei is available we always query by imei - it is the reliable filter
  // on gps_track_data_api (see curl reference), whereas regno-only lookups
  // can come back empty and leave the map with no marker for the selected
  // vehicle.
  const handleSelectVehicle = (vehicleOrItem) => {
    const isItem = vehicleOrItem && typeof vehicleOrItem === "object";
    const vehicle = isItem
      ? (vehicleOrItem.vehicle_registration_number || vehicleOrItem.regno || "")
      : vehicleOrItem;
    const imei = isItem ? (vehicleOrItem.imei || vehicleOrItem.IMEI || "") : "";

    setViewAllVehicles(false);
    setVehicleNo(vehicle);
    setDropdownOpen(false);
    setVehicleOptions([]);

    setSelectedId(null);
    setManualSearch(true);

    retriveMapData(
      imei ? { imei, regno: "" } : { regno: vehicle }
    );
  };

 const handleViewAllToggle = async (event) => {
    const checked = event.target.checked;

    setViewAllVehicles(checked);

    if (checked) {
        setVehicleNo("");
        setSelectedId(null);
        setFocusedEntry(null);

        setVehicleOptions([]);
        setDropdownOpen(false);

        // Fetch complete vehicle list
        fetchVehicleDropdown("", true);

        // Reload ALL live vehicles
        retriveMapData({
            regno: "",
            imei: "",
            owner: "",
            poi: "",
            roads: "",
            polygon: "",
            category: "",
            make: "",
            district: "",
            speed_limit: "",
            in_range: false,
            poi_as_polygon: false,
        });

    } else {
        setVehicleOptions([]);
        setDropdownOpen(false);
    }
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle input changes
  const handleInput = (event) => {
    const { name, value } = event.target;
    if (name === "vehicleNo") {
      setVehicleNo(value);
    } else if (name === "imeiNo") {
      setImeiNo(value);
    } else if (name === "owner") {
      setOwner(value);
    } else if (name === "poi") {
      setPoi(value);
    } else if (name === "roads") {
      setRoads(value);
    } else if (name === "polygon") {
      setPolygon(value);

    } else if (name === "category") {
      setCategory(value);
    } else if (name === "make") {
      setMake(value);
    } else if (name === "district") {
      setDistrict(value);
    } else if (name === "speedLimit") {
      setSpeedLimit(value);
    }
  };

  const computeRow = (processedItem) => {
    // Extract block_name and route_name
    const blockName = processedItem?.device_tag_info?.block?.name ||
      processedItem?.device_tag_info?.block_name ||
      processedItem?.device_tag_info?.device?.block_name ||
      processedItem?.device_tag_info?.device?.district ||
      processedItem?.device_tag_info?.district_info?.district ||
      processedItem?.device_tag_info?.state_info?.state ||
      processedItem?.block_name ||
      processedItem?.address ||
      processedItem?.nearest_poi?.data?.address ||
      '';

    const routeId = processedItem?.route_id ||
      processedItem?.device_tag_info?.route?.id ||
      processedItem?.nearby_routes_within_100m?.[0]?.data?.id;

    const routeName = processedItem?.device_tag_info?.route?.name ||
      processedItem?.device_tag_info?.route_name ||
      processedItem?.device_tag_info?.route_ref?.name ||
      processedItem?.route_name ||
      (routeId ? `Route: ${routeId}` : '');

    // Precompute status/icon
    const entryTimeMs = resolveEntryTimestampMs(processedItem);
    const nowMs = Date.now();
    const diffMin = Number.isFinite(entryTimeMs) ? calculateTimeDifference(entryTimeMs, nowMs) : Number.POSITIVE_INFINITY;
    const isStale = diffMin > 15;
    const ignitionOn = resolveIgnitionOn(processedItem);
    const speedValue = resolveSpeedValue(processedItem);

    let alartType;
    if (isStale) alartType = 'grey';
    else if (processedItem.packet_type === 'EA') alartType = 'red';
    else if (processedItem.packet_type !== 'NR') alartType = 'orange';
    else if (speedValue > 0) alartType = 'green';
    else if (ignitionOn && speedValue === 0) alartType = 'blue';
    else alartType = 'default';

    const vehicleType = processedItem?.device_tag_info?.category_info?.category;
    const colorMap = { grey: 'grey', red: 'red', orange: 'orange', blue: 'blue', green: 'green', default: 'default' };
    const color = colorMap[alartType] || 'default';
    const preIcon = createIconPath(color, vehicleType);

    return {
      ...processedItem,
      block_name: blockName,
      route_name: routeName,
      __alartType: alartType,
      __iconSrc: preIcon,
    };
  };

  const handleListScroll = useCallback(() => {
    const el = listContainerRef.current;
    if (!el || !fullRawRef.current) return;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 80;
    if (!nearBottom) return;

    const BATCH = 200;
    const nextEnd = Math.min(visibleCount + BATCH, fullRawRef.current.length);
    if (nextEnd <= visibleCount) return;

    const nextSlice = fullRawRef.current.slice(visibleCount, nextEnd).map(computeRow);
    fullDataRef.current = [...fullDataRef.current, ...nextSlice];
    setTableDataTop((prev) => [...prev, ...nextSlice]);
    if (typeFilter === 'default') {
      setFilteredData((prev) => [...prev, ...nextSlice]);
    }
    setVisibleCount(nextEnd);
  }, [visibleCount, typeFilter]);

  const handleVehicleMarkerClick = async (entry) => {
    if (!entry?.imei) return;

    setSelectedId(`vehicle-${entry.imei}`);
    setFilteredData([entry]);
    setFocusedEntry(entry);
    setUseNmrLocation(false);
    setNmrArea(null);
    if (isBadGnss(entry)) {
      const updated = await applyNmrLocation(entry);
      setFilteredData([updated]);
      setFocusedEntry(updated);
    }
  };

  const computeSearchCenter = useCallback((entries = []) => {
    const coords = entries
      .map((item) => {
        const latitude = Number(item.latitude);
        const longitude = Number(item.longitude);
        if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
          return { latitude, longitude };
        }
        return null;
      })
      .filter(Boolean);

    if (coords.length === 0) {
      return { latitude: 26.1445, longitude: 91.7362 }; // Guwahati default
    }

    const totals = coords.reduce(
      (acc, point) => {
        acc.latitude += point.latitude;
        acc.longitude += point.longitude;
        return acc;
      },
      { latitude: 0, longitude: 0 }
    );

    return {
      latitude: totals.latitude / coords.length,
      longitude: totals.longitude / coords.length,
    };
  }, []);

  const fetchPoliceLocations = useCallback(async (entries = []) => {
    try {
      // Build API params - only include lat/lon when a vehicle is selected
      const params = {
        user_type: 'police_ex',
      };

      // If entries exist (vehicle selected), add location-based filtering
      if (entries && entries.length > 0) {
        const center = computeSearchCenter(entries);
        params.lat = center.latitude;
        params.lon = center.longitude;
        params.radius_km = 10000;
      }

      const response = await HomePageService.getEmergencyUserLocations(params);

      // Parse the nested response structure
      const payload = response?.data ?? {};
      let records = [];

      // Handle the structure: { results: { data: [...] } }
      if (payload?.results?.data && Array.isArray(payload.results.data)) {
        records = payload.results.data;
      } else if (Array.isArray(payload?.results)) {
        records = payload.results;
      } else if (Array.isArray(payload?.data)) {
        records = payload.data;
      } else if (Array.isArray(payload)) {
        records = payload;
      }

      const normalized = records
        .map((item, index) => {
          // Extract location from em_lat and em_lon at root level
          const latitude = Number(item?.em_lat ?? item?.latitude ?? item?.lat);
          const longitude = Number(item?.em_lon ?? item?.longitude ?? item?.lon);

          if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
            return null;
          }

          // Extract user info from field_ex
          const fieldEx = item?.field_ex ?? {};
          const users = fieldEx?.users ?? [];
          const primaryUser = users[0] ?? {};

          // Extract timestamp from time field or field_ex
          const lastUpdatedRaw = item?.time ?? fieldEx?.created ?? item?.timestamp;
          const lastUpdated = lastUpdatedRaw ? new Date(lastUpdatedRaw).toISOString() : new Date().toISOString();

          // Create label from user name or fallback
          const userName = primaryUser?.name || fieldEx?.idProofno || `Police #${index + 1}`;
          const labelFallback = userName;

          return {
            id: item?.id || fieldEx?.id || `police-${index}`,
            vehicle_registration_number: userName,
            block_name: fieldEx?.district_info?.district || fieldEx?.state_info?.state || '',
            route_name: '',
            markerLabel: labelFallback,
            markerCategory: 'police',
            packet_type: 'POLICE',
            ignition_status: 1, // Assume active
            speed: Number(item?.speed) || 0,
            entry_time: lastUpdated,
            date: lastUpdated.split('T')[0] ?? '',
            time: lastUpdated.split('T')[1]?.split('Z')[0] ?? '',
            internal_battery_voltage: '--',
            main_input_voltage: '--',
            latitude,
            longitude,
          };
        })
        .filter(Boolean);

      setPoliceLocations(normalized);
    } catch (error) {
      console.error('Error fetching police locations:', error);
      setPoliceLocations([]);
    }
  }, [computeSearchCenter]);

  const fetchIncidents = useCallback(async (entries = []) => {
    try {
      const center = computeSearchCenter(entries);
      const response = await HomePageService.getIncidentData({
        latitude: center.latitude,
        longitude: center.longitude,
        radius_km: 50, // Default radius
        page: 1,
        page_size: 100,
        // Add date range if needed, e.g., current year
        registered_at_from: new Date(new Date().getFullYear(), 0, 1).toISOString().split('T')[0],
        registered_at_to: new Date(new Date().getFullYear(), 11, 31).toISOString().split('T')[0],
      });

      if (response && response.data && response.data.status === "success" && Array.isArray(response.data.data)) {
        setIncidentData(response.data.data);
      } else {
        setIncidentData([]);
      }
    } catch (error) {
      console.error('Error fetching incidents:', error);
      setIncidentData([]);
    }
  }, [computeSearchCenter]);

  const handleMapModeChange = (mode) => {
    setMapMode(mode);
  };

  const isBadGnss = (entry) => {
    const lat = Number(entry?.latitude);
    const lon = Number(entry?.longitude);
    return (
      !Number.isFinite(lat) ||
      !Number.isFinite(lon) ||
      (lat === 0 && lon === 0)
    );
  };

  const applyNmrLocation = async (entry) => {
    const mcc = entry?.mcc;
    const mnc = entry?.mnc;
    const lac = entry?.lac;
    const cellId = entry?.cell_id;

    if (!mcc || !mnc || !lac || !cellId) {
      return entry;
    }

    try {
      const payload = {
        mcc: String(mcc),
        mnc: String(mnc),
        lac: String(lac),
        cell_id: String(cellId),
      };

      const nmrResponse = await HomePageService.getCellLocation(payload);
      const latValue = nmrResponse?.data?.average_latitude ?? nmrResponse?.data?.lat ?? nmrResponse?.data?.latitude;
      const lonValue = nmrResponse?.data?.average_longitude ?? nmrResponse?.data?.lon ?? nmrResponse?.data?.lng ?? nmrResponse?.data?.longitude;

      const lat = Number(latValue);
      const lon = Number(lonValue);

      if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
        return entry;
      }

      // Automatic NMR fallback: update coordinates only, do NOT show circle
      return { ...entry, latitude: lat, longitude: lon };
    } catch (e) {
      return entry;
    }
  };

  let activeCancel = null;
  const retriveMapData = async (data) => {
    try {
      if (activeCancel) {
        activeCancel.cancel('replaced by a newer request');
      }
      activeCancel = axios.CancelToken.source();

      const retriveData_table = await HomePageService.getLiveTracking_data(
        { ...data },
        { cancelToken: activeCancel.token }
      );


      if (Array.isArray(retriveData_table.data.data)) {
        const rawData = retriveData_table.data.data;
        fullRawRef.current = rawData;

        const nextCategorySpeedMap = rawData.reduce((acc, item) => {
          const catRaw =
            item?.device_tag_info?.category_info?.category ??
            item?.category_info?.category ??
            item?.category;
          const cat = normalizeCategoryKey(catRaw);
          if (!cat) return acc;
          const speedValue = item?.device_tag_info?.category_info?.maxSpeed ??
            item?.device_tag_info?.category_info?.max_speed ??
            item?.category_info?.maxSpeed ??
            item?.category_info?.max_speed ??
            '';
          if (speedValue !== '' && speedValue !== null && speedValue !== undefined) {
            acc[cat] = String(speedValue);
          }
          return acc;
        }, {});
        setCategorySpeedMap(nextCategorySpeedMap);

        const maxSpeedValue = rawData?.[0]?.device_tag_info?.category_info?.maxSpeed ??
          rawData?.[0]?.device_tag_info?.category_info?.max_speed ??
          rawData?.[0]?.category_info?.maxSpeed ??
          rawData?.[0]?.category_info?.max_speed ??
          '';
        setCategoryMaxSpeed(category && rawData.length > 0 ? String(maxSpeedValue || '') : '');
        // Lazy rendering: keep full list in ref and render initial chunk only
        const INITIAL_CHUNK = 50; // smaller initial paint for faster perceived load
        const CHUNK_SIZE = 200;

        const firstSlice = rawData.slice(0, INITIAL_CHUNK).map(computeRow);
        fullDataRef.current = firstSlice;
        setTableDataTop(firstSlice);
        setFilteredData(firstSlice);
        setVisibleCount(firstSlice.length);
        setLoad(true);

        // If there's exactly one vehicle, select it automatically
        if (rawData.length === 1) {
          let singleRaw = rawData[0];

          // If the device has no/invalid GPS fix, fall back to a
          // cell-tower (NMR) based location so the marker still has
          // coordinates to render at instead of disappearing.
          if (isBadGnss(singleRaw)) {
            singleRaw = await applyNmrLocation(singleRaw);
          }

          const singleRow = computeRow(singleRaw);
          setSelectedId(`vehicle-${singleRaw.imei}`);
          setFocusedEntry(singleRow);
          // Keep the list + map data in sync with the (possibly NMR
          // corrected) coordinates for the selected vehicle.
          setFilteredData([singleRow]);
          setTableDataTop([singleRow]);
        } else {
          setSelectedId(null);
          setFocusedEntry(null);
        }

        // Defer auxiliary data fetches to avoid blocking first paint
        setTimeout(() => {
          const all = fullRawRef.current?.length ? fullRawRef.current : rawData;
          fetchPoliceLocations(all);
          fetchIncidents(all);
        }, 0);
      } else {
        setTableDataTop([]);
        setFilteredData([]);
        setSelectedId(null);
        setFocusedEntry(null);
        setCategoryMaxSpeed('');
        setCategorySpeedMap({});
        setUseNmrLocation(false);
        setNmrArea(null);
        fetchPoliceLocations();
        fetchIncidents();
      }
      // load state now set earlier for faster perceived rendering
    } catch (error) {
      setTableDataTop([]);
      setFilteredData([]);
      setSelectedId(null);
      setFocusedEntry(null);
      setCategoryMaxSpeed('');
      setCategorySpeedMap({});
      setUseNmrLocation(false);
      setNmrArea(null);
      fetchPoliceLocations();
      fetchIncidents();
    }
  };

  const getReverseGeocodeCacheKey = (lat, lon) => {
    const latNum = Number(lat);
    const lonNum = Number(lon);
    if (!Number.isFinite(latNum) || !Number.isFinite(lonNum)) return null;
    return `${latNum.toFixed(5)},${lonNum.toFixed(5)}`;
  };

  const reverseGeocode = async (lat, lon) => {
    try {
      const response = await HomePageService.getReverseGeocode(lat, lon);
      const payload = response?.data;

      let city = "";
      let area = "";
      let address = "";

      // 1. Check for the flat structure shown by the user
      if (payload && typeof payload === 'object' && !payload.results) {
        city = payload.city || "";
        area = payload.area || "";
        address = payload.address || "";
        return { address, city, area };
      }

      // 2. Fallback to nested results structure
      const result = payload?.results?.[0];
      if (result) {
        if (Array.isArray(result.address_components)) {
          const cityComp = result.address_components.find((c) =>
            c.types.includes("locality") ||
            c.types.includes("administrative_area_level_2") ||
            c.types.includes("administrative_area_level_3")
          );
          if (cityComp) city = cityComp.long_name;
        }
        address = result.formatted_address || (typeof payload?.address === "string" ? payload.address.trim() : "");
        return { address, city, area: "" };
      }

      const fallbackAddress = typeof payload?.address === "string" ? payload.address.trim() : "";
      return { address: fallbackAddress, city: "", area: "" };
    } catch (error) {
      console.error("Reverse geocode error:", error);
      return { address: "", city: "" };
    }
  };

  useEffect(() => {
    const lat = focusedEntry?.latitude;
    const lon = focusedEntry?.longitude;
    const cacheKey = getReverseGeocodeCacheKey(lat, lon);

    if (!focusedEntry || !cacheKey) return;
    // Remove the early return for address so we can ensure geocoding (which populates block_name) runs
    // if block_name is missing or a fallback.
    const hasValidBlock = focusedEntry.block_name && focusedEntry.block_name !== "" && focusedEntry.block_name !== "china";
    if (focusedEntry.address && hasValidBlock) return;

    const cached = reverseGeocodeCache[cacheKey];
    if (cached && typeof cached === "object") {
      const { address, block_name } = cached;
      if (!address && !block_name) return;

      setFocusedEntry((prev) => (prev ? { ...prev, address, block_name: block_name || prev.block_name } : prev));
      setFilteredData((prev) =>
        prev.map((row) =>
          row?.imei === focusedEntry?.imei ? { ...row, address, block_name: block_name || row.block_name } : row
        )
      );
      setTableDataTop((prev) =>
        prev.map((row) =>
          row?.imei === focusedEntry?.imei ? { ...row, address, block_name: block_name || row.block_name } : row
        )
      );
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        console.debug(`[LiveTracking] Fetching reverse geocode for: ${lat}, ${lon}`);
        const { address, city, area } = await reverseGeocode(lat, lon);
        if (cancelled) return;

        const effectiveBlockName = city || area || address || "";
        setReverseGeocodeCache((prev) => ({ ...prev, [cacheKey]: { address: address || "", block_name: effectiveBlockName } }));

        setFocusedEntry((prev) => (prev ? { ...prev, address: address || "", block_name: effectiveBlockName || prev.block_name } : prev));
        setFilteredData((prev) =>
          prev.map((row) =>
            row?.imei === focusedEntry?.imei ? { ...row, address: address || "", block_name: effectiveBlockName || row.block_name } : row
          )
        );
        setTableDataTop((prev) =>
          prev.map((row) =>
            row?.imei === focusedEntry?.imei ? { ...row, address: address || "", block_name: effectiveBlockName || row.block_name } : row
          )
        );
      } catch (error) {
        if (cancelled) return;
        setReverseGeocodeCache((prev) => ({ ...prev, [cacheKey]: { address: "", block_name: "" } }));
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [focusedEntry?.imei, focusedEntry?.latitude, focusedEntry?.longitude, focusedEntry?.address, reverseGeocodeCache]);

  // Handle button click, update selectedId and filtered data
  const handleButtonClick = async (id) => {
    let selectedRow = tableDataTop.find((row) => `vehicle-${row.imei}` === id);
    if (!selectedRow) {
      selectedRow = (fullDataRef.current || []).find((row) => `vehicle-${row.imei}` === id);
    }

    if (selectedRow) {
      setSelectedId(id);
      setFilteredData([selectedRow]);
      setFocusedEntry(selectedRow);
      setUseNmrLocation(false);
      setNmrArea(null);
      if (isBadGnss(selectedRow)) {
        const updated = await applyNmrLocation(selectedRow);
        setFilteredData([updated]);
        setFocusedEntry(updated);
      }
    } else {
      setSelectedId(null);
      setFilteredData(tableDataTop);
      setFocusedEntry(null);
      setUseNmrLocation(false);
      setNmrArea(null);
    }
  };

  // Triggered on form submit to fetch new data
  const handleSubmit = (event) => {
    event.preventDefault();
    setManualSearch(false);
    const params = {
      imei: imeiNo,
      regno: vehicleNo,
      owner: owner,
      poi: poi,
      poi_id: poi,
      roads: roads,
      route_id: '',
      polygon: polygon,
      category: category,
      make: make,
      district: district,
      district_id: '',
      manufacturer_id: '',
      speed_limit: speedLimit,
      in_range: inRange,
      poi_as_polygon: poiAsPolygon,
    };

    setSelectedId(null); // Reset selection when submitting new search
    setFocusedEntry(null);
    setUseNmrLocation(false);
    setNmrArea(null);

    retriveMapData(params);
  };

  useEffect(() => {
    if (manualSearch) return;
    const params = {
      imei: imeiNo,
      regno: vehicleNo,
      owner: owner,
      poi: poi,
      poi_id: poi,
      roads: roads,
      route_id: '',
      polygon: polygon,
      category: category,
      make: make,
      district: district,
      district_id: '',
      manufacturer_id: '',
      speed_limit: speedLimit,
      in_range: inRange,
      poi_as_polygon: poiAsPolygon,
    };

    // Single fetch when filters/inputs change, no repeating interval
    retriveMapData(params);
  }, [imeiNo, vehicleNo, owner, poi, roads, polygon, category, make, district, inRange, poiAsPolygon]);

  const refreshSelectedVehicle = async () => {
    if (!selectedId) return;

    const selectedRow = tableDataTop.find((row) => `vehicle-${row.imei}` === selectedId);
    if (!selectedRow) return;

    const params = {
      imei: selectedRow.imei,
      regno: '',
      owner: '',
      poi: '',
      poi_id: poi,
      roads: '',
      route_id: '',
      polygon: '',
      category: '',
      make: '',
      district: '',
      district_id: '',
      manufacturer_id: '',
      speed_limit: speedLimit,
      in_range: inRange,
      poi_as_polygon: poiAsPolygon,
    };

    try {
      const response = await HomePageService.getLiveTracking_data(params);
      if (Array.isArray(response?.data?.data) && response.data.data.length > 0) {
        let updated = response.data.data[0];

        if (isBadGnss(updated)) {
          updated = await applyNmrLocation(updated);
        } else if (useNmrLocation) {
          updated = await applyNmrLocation(updated);
        }

        setFilteredData([updated]);
        setFocusedEntry(updated);
      }
    } catch (error) {
      // Ignore refresh errors for selected vehicle
    }
  };

  useEffect(() => {
    if (!selectedId) return;

    const intervalId = setInterval(() => {
      refreshSelectedVehicle();
    }, 10000);

    return () => clearInterval(intervalId);
  }, [selectedId, tableDataTop]);

  // Helper to calculate time difference in minutes
  const calculateTimeDifference = (startTime, endTime) => {
    const timeDifferenceMillis = endTime - startTime;
    return timeDifferenceMillis / (1000 * 60); // Convert milliseconds to minutes
  };

  const resolveEntryTimestampMs = (data) => {
    if (!data) return NaN;

    const raw = data.entry_time ?? data.timestamp ?? null;

    const normalizeEpoch = (value) => {
      const num = typeof value === "number" ? value : Number(value);
      if (!Number.isFinite(num)) return NaN;
      return num < 1e12 ? num * 1000 : num;
    };

    if (typeof raw === "number") {
      return normalizeEpoch(raw);
    }

    if (typeof raw === "string") {
      const trimmed = raw.trim();
      if (/^\d+$/.test(trimmed)) {
        return normalizeEpoch(trimmed);
      }
      const parsed = new Date(trimmed).getTime();
      if (Number.isFinite(parsed)) return parsed;
    }

    const parseDateTimeParts = (dateStr, timeStr) => {
      if (!dateStr || !timeStr) return NaN;

      const dateTrimmed = String(dateStr).trim();
      const timeTrimmed = String(timeStr).trim();

      // Format: DDMMYYYY + HHMMSS (e.g., 15122025 + 234041)
      const dmyCompact = dateTrimmed.match(/^(\d{2})(\d{2})(\d{4})$/);
      const hmsCompact = timeTrimmed.match(/^(\d{2})(\d{2})(\d{2})$/);
      if (dmyCompact && hmsCompact) {
        const day = Number(dmyCompact[1]);
        const month = Number(dmyCompact[2]);
        const year = Number(dmyCompact[3]);
        const hours = Number(hmsCompact[1]);
        const minutes = Number(hmsCompact[2]);
        const seconds = Number(hmsCompact[3]);
        const dt = new Date(year, month - 1, day, hours, minutes, seconds);
        const ms = dt.getTime();
        return Number.isFinite(ms) ? ms : NaN;
      }

      // Format: DD-MM-YY or DD-MM-YYYY
      const dmy = dateTrimmed.match(/^(\d{1,2})-(\d{1,2})-(\d{2}|\d{4})$/);
      if (dmy) {
        const day = Number(dmy[1]);
        const month = Number(dmy[2]);
        let year = Number(dmy[3]);
        if (String(dmy[3]).length === 2) year = 2000 + year;

        // Time: HH:MM(:SS)? (AM/PM optional)
        const tm = timeTrimmed.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?$/i);
        if (!tm) return NaN;
        let hours = Number(tm[1]);
        const minutes = Number(tm[2]);
        const seconds = Number(tm[3] ?? 0);
        const ampm = tm[4]?.toUpperCase();
        if (ampm === "AM") {
          if (hours === 12) hours = 0;
        } else if (ampm === "PM") {
          if (hours !== 12) hours += 12;
        }

        const dt = new Date(year, month - 1, day, hours, minutes, seconds);
        const ms = dt.getTime();
        return Number.isFinite(ms) ? ms : NaN;
      }

      // Fallback: try native parsing for other formats
      const fallbackMs = new Date(`${dateTrimmed} ${timeTrimmed}`).getTime();
      return Number.isFinite(fallbackMs) ? fallbackMs : NaN;
    };

    const datePart = data?.date;
    const timePart = data?.time;
    if (datePart && timePart) {
      const compositeMs = parseDateTimeParts(datePart, timePart);
      if (Number.isFinite(compositeMs)) return compositeMs;

      const compositeParsed = new Date(`${datePart}T${timePart}`).getTime();
      if (Number.isFinite(compositeParsed)) return compositeParsed;
    }

    return NaN;
  };

  const createIconPath = (color, vehicleType) => {
    const normalizedVehicleType = vehicleType ? String(vehicleType).toLowerCase().trim() : 'bus';
    const availableTypes = ['ambulance', 'bus', 'dumper', 'police', 'school bus', 'tanker', 'taxi', 'truck'];
    const iconType = availableTypes.includes(normalizedVehicleType) ? normalizedVehicleType : 'bus';
    const fileName = `${iconType}.png`;

    try {
      return vehicleIconContext(`./${color}/${fileName}`);
    } catch (error) {
      try {
        return vehicleIconContext(`./${color}/bus.png`);
      } catch (fallbackError) {
        return vehicleIconContext(`./default/bus.png`);
      }
    }
  };

  const resolveIgnitionOn = (entry) => String(entry?.ignition_status ?? entry?.ignitionStatus ?? "") === "1";

  const resolveSpeedValue = (entry) => {
    const raw = entry?.speed ?? entry?.vehicle_speed ?? entry?.vehicleSpeed;
    const num = typeof raw === "number" ? raw : Number(raw);
    return Number.isFinite(num) ? num : 0;
  };

  // speed >= 1 => "ontrip", otherwise "stopped"
  const getTripStatus = (entry) => (resolveSpeedValue(entry) >= 1 ? "ontrip" : "stopped");

  const getIconStyle = (data) => {
    const entryTimeMs = resolveEntryTimestampMs(data);
    const currentTimeMs = new Date().getTime();
    const timeDifference = Number.isFinite(entryTimeMs)
      ? calculateTimeDifference(entryTimeMs, currentTimeMs)
      : Number.POSITIVE_INFINITY;
    const isStale = timeDifference > 15;

    // Get vehicle type from data
    const vehicleType = data?.device_tag_info?.category_info?.category;

    const ignitionOn = resolveIgnitionOn(data);
    const speedValue = resolveSpeedValue(data);

    let color;
    if (isStale) {
      color = 'grey'; // Offline device (no packets from device for 15+ minutes) - Grey Icon
    } else if (data.packet_type === "EA") {
      color = 'red'; // EA Packet - Red Icon
    } else if (data.packet_type !== "NR") {
      color = 'orange'; // Any Alert Packet except EA - Orange Icon
    } else if (speedValue > 0) {
      color = 'green'; // Moving - Green Icon
    } else if (ignitionOn && speedValue === 0) {
      color = 'blue'; // Ignition ON but stationary - Blue Icon
    } else {
      color = 'default'; // Default icon for all other conditions
    }

    return createIconPath(color, vehicleType);
  };

  const getAlartType = (data) => {
    const entryTimeMs = resolveEntryTimestampMs(data);
    const currentTimeMs = new Date().getTime();
    const timeDifference = Number.isFinite(entryTimeMs)
      ? calculateTimeDifference(entryTimeMs, currentTimeMs)
      : Number.POSITIVE_INFINITY;
    const isStale = timeDifference > 15;

    const ignitionOn = resolveIgnitionOn(data);
    const speedValue = resolveSpeedValue(data);

    if (isStale) {
      return "grey"; // Offline device (no packets from device for 15+ minutes) - Grey Icon
    } else if (data.packet_type === "EA") {
      return "red"; // EA Packet - Red Icon
    } else if (data.packet_type !== "NR") {
      return "orange"; // Any Alert Packet except EA - Orange Icon
    } else if (speedValue > 0) {
      return "green"; // Moving - Green Icon
    } else if (ignitionOn && speedValue === 0) {
      return "blue"; // Ignition ON but stationary - Blue Icon
    } else {
      return "default"; // Default icon for all other conditions
    }
  };

  const filterByType = (data) => {
    setTypeFilter(data);
    setSelectedId(null); // Reset selection when changing filter

    if (data === "default") {
      setFilteredData(tableDataTop);
      setFocusedEntry(null);
    } else if (data === "online") {
      const filteredRows = tableDataTop.filter(row => (row.__alartType ?? getAlartType(row)) !== "grey");
      setFilteredData(filteredRows);

      if (filteredRows.length === 1) {
        setSelectedId(`vehicle-${filteredRows[0].imei}`);
        setFocusedEntry(filteredRows[0]);
      } else {
        setSelectedId(null);
        setFocusedEntry(null);
      }
    } else {
      const filteredRows = tableDataTop.filter(row => (row.__alartType ?? getAlartType(row)) === data);
      setFilteredData(filteredRows);

      // If there's exactly one result after filtering, select it automatically
      if (filteredRows.length === 1) {
        setSelectedId(`vehicle-${filteredRows[0].imei}`);
        setFocusedEntry(filteredRows[0]);
      } else {
        setSelectedId(null);
        setFocusedEntry(null);
      }
    }
  };

  const checkType = (type, data) => {
    const alartType = data?.__alartType ?? getAlartType(data);
    if (type === "default") return true;
    if (type === "online") return alartType !== "grey";
    return alartType === type;
  };

  // HEADER TABS: All Vehicles / On Trip / Stopped
  // Filters the currently loaded vehicle set by speed-derived trip status
  // (speed >= 1 => On Trip, else Stopped) and drives both the sidebar list
  // and the map.
  const handleTripTabChange = (tab) => {
    setTripFilter(tab);
    setSelectedId(null);
    setFocusedEntry(null);
    setUseNmrLocation(false);
    setNmrArea(null);

    // Use the full raw dataset (not just the lazily-paginated slice) so the
    // tabs reflect every vehicle currently loaded, not only what has been
    // scrolled into view.
    const allRows = (fullRawRef.current || []).map(computeRow);
    const baseRows = allRows.length ? allRows : tableDataTop;

    if (tab === "all") {
      setFilteredData(baseRows);
      return;
    }

    const filteredRows = baseRows.filter((row) => getTripStatus(row) === tab);
    setFilteredData(filteredRows);

    if (filteredRows.length === 1) {
      setSelectedId(`vehicle-${filteredRows[0].imei}`);
      setFocusedEntry(filteredRows[0]);
    }
  };

  const getDisplayCellValue = (row, key) => {
    if (!row) return "";

    if (key === "packet_type" || key === "packet_status") {
      const entryTimeMs = resolveEntryTimestampMs(row);
      const currentTimeMs = new Date().getTime();
      const timeDifference = Number.isFinite(entryTimeMs)
        ? calculateTimeDifference(entryTimeMs, currentTimeMs)
        : Number.POSITIVE_INFINITY;
      if (timeDifference > 15) return "Offline";
    }

    if (key === "ignition_status") {
      const ignitionOn = resolveIgnitionOn(row);
      if (!ignitionOn) return "Engine OFF";
      const speedValue = resolveSpeedValue(row);
      return speedValue <= 1 ? "Engine ON (Stationary)" : "Engine ON";
    }

    const rawValue = row[key];
    return (
      fullText?.[rawValue] ||
      (isoDatePattern.test(rawValue) && formatDateTime(rawValue)) ||
      rawValue ||
      ""
    );
  };

  return (
    <Box sx={{ display: 'flex', height: '80vh', bgcolor: '#f4f7f9', overflow: 'hidden' }}>
      {/* LEFT SIDEBAR */}
      <Box sx={{
        width: '320px',
        bgcolor: '#fff',
        borderRight: '1px solid #e0e0e0',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header Tabs */}
        <Box sx={{ bgcolor: '#17345f', p: 0.5, display: 'flex' }}>
          <Button
            fullWidth
            onClick={() => handleTripTabChange('all')}
            sx={{
              color: '#fff',
              borderBottom: tripFilter === 'all' ? '3px solid #fff' : '3px solid transparent',
              borderRadius: 0,
              textTransform: 'none',
              fontWeight: tripFilter === 'all' ? 600 : 400,
              opacity: tripFilter === 'all' ? 1 : 0.6
            }}
          >
            All Vehicles
          </Button>
          <Button
            fullWidth
            onClick={() => handleTripTabChange('ontrip')}
            sx={{
              color: '#fff',
              borderBottom: tripFilter === 'ontrip' ? '3px solid #fff' : '3px solid transparent',
              borderRadius: 0,
              textTransform: 'none',
              fontWeight: tripFilter === 'ontrip' ? 600 : 400,
              opacity: tripFilter === 'ontrip' ? 1 : 0.6
            }}
          >
            On Trip
          </Button>
          <Button
            fullWidth
            onClick={() => handleTripTabChange('stopped')}
            sx={{
              color: '#fff',
              borderBottom: tripFilter === 'stopped' ? '3px solid #fff' : '3px solid transparent',
              borderRadius: 0,
              textTransform: 'none',
              fontWeight: tripFilter === 'stopped' ? 600 : 400,
              opacity: tripFilter === 'stopped' ? 1 : 0.6
            }}
          >
            Stopped
          </Button>
        </Box>

        {/* Search and Content Container */}
        <Box sx={{ p: 2, overflowY: 'auto', flexGrow: 1 }}>
          {/* Search Input */}
          <Box ref={dropdownRef} sx={{ position: 'relative', mb: 2 }}>
            <TextField
              fullWidth
              placeholder="Vehicle Registration No."
              value={vehicleNo}
              onChange={handleVehicleSearch}
              size="small"
              InputProps={{
                startAdornment: (
                  <SearchIcon
                    sx={{
                      color: '#999',
                      mr: 1,
                      fontSize: '20px'
                    }}
                  />
                ),
                sx: {
                  borderRadius: '8px',
                  bgcolor: '#f8f9fa'
                }
              }}
            />

            {dropdownOpen && vehicleOptions.length > 0 && (
              <Paper
                elevation={4}
                sx={{
                  position: "absolute",
                  top: "105%",
                  left: 0,
                  width: "100%",
                  maxHeight: 250,
                  overflowY: "auto",
                  zIndex: 9999,
                  borderRadius: 2,
                  boxShadow: "0px 6px 20px rgba(0,0,0,0.15)",
                  bgcolor: "#fff"
                }}
              >
                {vehicleOptions.map((item, index) => {
                  const label =
                    typeof item === "string"
                      ? item
                      : item.vehicle_registration_number || item.regno;

                  return (
                    <MenuItem
                      key={`${label}-${index}`}
                      onClick={() => handleSelectVehicle(item)}
                    >
                      {label}
                    </MenuItem>
                  );
                })}
              </Paper>
            )}
          </Box>
          {/* Vehicle List Mapping */}
          <Box sx={{ mb: 3 }}>
            {(viewAllVehicles ? vehicleOptions : filteredData).length === 0 ? (
              <Typography align="center" sx={{ color: '#999', py: 4 }}>{vehicleNo ? "No Data Available" : "No Vehicle Selected"}</Typography>
            ) : (
              (viewAllVehicles ? vehicleOptions : filteredData).map((row) => {
                const vehicle =
                  typeof row === "string"
                    ? row
                    : row.vehicle_registration_number || row.regno;
                return (
                  <Paper
                    key={row.imei}
                    // onClick={() => handleButtonClick(`vehicle-${row.imei}`)}
                    onClick={() =>
                      viewAllVehicles
                        ? handleSelectVehicle(row)
                        : handleButtonClick(`vehicle-${row.imei}`)
                    }
                    elevation={0}
                    sx={{
                      p: 1.5, mb: 1, borderRadius: '10px', cursor: 'pointer',
                      // border: selectedId === `vehicle-${row.imei}` ? '1.5px solid #17345f' : '1px solid #d1d9e6',
                      // bgcolor: selectedId === `vehicle-${row.imei}` ? '#f0f7ff' : '#fff',
                      border:
                        !viewAllVehicles &&
                          selectedId === `vehicle-${row.imei}`
                          ? "1.5px solid #17345f"
                          : "1px solid #d1d9e6",
                      bgcolor:
                        !viewAllVehicles &&
                          selectedId === `vehicle-${row.imei}`
                          ? "#f0f7ff"
                          : "#fff",
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        {/* <Box component="img" src={row.__iconSrc} sx={{ width: 32, height: 32 }} /> */}
                        {!viewAllVehicles && (
                          <Box
                            component="img"
                            src={row.__iconSrc}
                            sx={{ width: 32, height: 32 }}
                          />
                        )}
                        <Box>
                          <Typography sx={{ fontSize: '10px', color: '#888' }}>Registration No</Typography>
                          <Typography sx={{ fontSize: '13px', fontWeight: 700 }}>{row.vehicle_registration_number}</Typography>
                        </Box>
                      </Box>
                      {!viewAllVehicles && (
                        <Box sx={{ textAlign: 'right' }}>
                          <Typography sx={{ fontSize: '10px', color: '#888' }}>Status</Typography>
                          <Typography sx={{ fontSize: '12px', fontWeight: 700, color: getTripStatus(row) === 'ontrip' ? 'green' : 'orange' }}>
                            {row.speed} km/h · {getTripStatus(row) === 'ontrip' ? 'On Trip' : 'Stopped'}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Paper>
                )
              })
            )}
          </Box>

          {/* REAL DATA SECTIONS - Displays when a vehicle is selected */}
          {focusedEntry && (
            <Box>
              {/* Live Route Details from nearest_poi */}
              <Box sx={{ pt: 2, borderTop: '1px solid #eee', mb: 3 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#555', mb: 2 }}>Route Details</Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#17345f', border: '2px solid #fff', boxShadow: 1 }} />
                    <Box sx={{ width: '2px', flexGrow: 1, bgcolor: '#f0f0f0', my: 0.5 }} />
                    <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#ccc', border: '2px solid #fff' }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#333' }}>
                      {focusedEntry.nearest_poi?.data?.name || "Detecting Location..."}
                    </Typography>
                    <Typography sx={{ fontSize: '11px', color: '#888', mb: 1 }}>
                      {focusedEntry.nearest_poi?.distance_meters ? `${focusedEntry.nearest_poi.distance_meters}m away` : ""}
                    </Typography>
                    <Typography sx={{ fontSize: '11px', color: '#666' }}>
                      Area: {focusedEntry.nearest_poi?.data?.area || "N/A"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Live Alerts Section */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#555', mb: 1 }}>Alerts</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {focusedEntry.packet_type === 'EA' && (
                    <Box sx={{ bgcolor: '#ffebee', color: '#d32f2f', px: 1, py: 0.5, borderRadius: '4px', fontSize: '10px', fontWeight: 700 }}>
                      EMERGENCY
                    </Box>
                  )}
                  {Number(focusedEntry.speed) > Number(focusedEntry.device_tag_info?.category_info?.maxSpeed || 50) && (
                    <Box sx={{ bgcolor: '#fff3e0', color: '#ef6c00', px: 1, py: 0.5, borderRadius: '4px', fontSize: '10px', fontWeight: 700 }}>
                      OVERSPEED
                    </Box>
                  )}
                  {focusedEntry.ignition_status === "0" && (
                    <Box sx={{ bgcolor: '#f5f5f5', color: '#616161', px: 1, py: 0.5, borderRadius: '4px', fontSize: '10px', fontWeight: 700 }}>
                      IGNITION OFF
                    </Box>
                  )}
                  {focusedEntry.packet_type === 'NR' && <Typography variant="caption" sx={{ color: '#999' }}>No active alerts</Typography>}
                </Box>
              </Box>

              {/* Driver / Owner Info Section */}
              <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: '12px', border: '1px solid #edf2f7' }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#17345f', mb: 1.5 }}>Owner & Vehicle Info</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: '10px', color: '#888', textTransform: 'uppercase' }}>Owner Name</Typography>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>
                      {focusedEntry.device_tag_info?.vehicle_owner?.users[0]?.name || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ fontSize: '10px', color: '#888', textTransform: 'uppercase' }}>Contact</Typography>
                    <Typography sx={{ fontSize: '12px' }}>
                      {focusedEntry.device_tag_info?.vehicle_owner?.users[0]?.mobile || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ fontSize: '10px', color: '#888', textTransform: 'uppercase' }}>Make / Model</Typography>
                    <Typography sx={{ fontSize: '12px' }}>
                      {focusedEntry.device_tag_info?.vehicle_make} {focusedEntry.device_tag_info?.vehicle_model}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      {/* RIGHT SIDE - MAP */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Map Header */}
        <Box sx={{ bgcolor: '#17345f', p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button size="small" variant={mapMode === 'roadmap' ? 'contained' : 'text'} onClick={() => handleMapModeChange('roadmap')} sx={{ color: '#fff', bgcolor: mapMode === 'roadmap' ? '#3a506b' : 'transparent', textTransform: 'none' }}>Map</Button>
            <Button size="small" variant={mapMode === 'satellite' ? 'contained' : 'text'} onClick={() => handleMapModeChange('satellite')} sx={{ color: '#fff', bgcolor: mapMode === 'satellite' ? '#3a506b' : 'transparent', textTransform: 'none' }}>Satellite</Button>
            <Button size="small" variant={mapMode === 'hybrid' ? 'contained' : 'text'} onClick={() => handleMapModeChange('hybrid')} sx={{ color: '#fff', bgcolor: mapMode === 'hybrid' ? '#3a506b' : 'transparent', textTransform: 'none' }}>Hybrid</Button>
            {isSuperAdmin && (
              <FormControlLabel
                sx={{
                  ml: 2,
                  '& .MuiFormControlLabel-label': {
                    color: '#fff',
                    fontSize: '13px',
                    fontWeight: 600
                  }
                }}
                control={
                  <Switch
                    checked={viewAllVehicles}
                    onChange={handleViewAllToggle}
                    size="small"
                  />
                }
                label="View All Vehicles"
              />
            )}
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" sx={{ color: '#fff' }}>View Layers</Typography>
            <Select size="small" value={markerLabelMode} onChange={(e) => setMarkerLabelMode(e.target.value)} sx={{ bgcolor: '#fff', height: '30px', fontSize: '12px', minWidth: '130px' }}>
              <MenuItem value="vehicle">Vehicle ID/Reg</MenuItem>
            </Select>
            <Select size="small" value={mapType} onChange={(e) => setMapType(e.target.value)} sx={{ bgcolor: '#fff', height: '30px', fontSize: '12px', minWidth: '120px' }}>
              <MenuItem value="google">Google Map</MenuItem>
              <MenuItem value="osm">OpenStreetMap</MenuItem>
            </Select>
            <Button size="small" variant="outlined" sx={{ color: '#fff', borderColor: '#fff', height: '30px', textTransform: 'none' }}>Refresh</Button>
          </Box>
        </Box>

        {/* Map View */}
        <Box sx={{ flexGrow: 1 }}>
          {mapType === "google" ? (
            <GoogleMapComponent gpsData={filteredData} focusEntry={focusedEntry} mapTypeId={mapMode} height="100%" />
          ) : (
            <OpenStreetMapComponent gpsData={filteredData} focusEntry={focusedEntry} height="100%" />
          )}
        </Box>
      </Box>
    </Box>

    // <MainCard >
    //   <Typography variant="h4" sx={{
    //     fontWeight: 700,
    //     mb: 2,
    //     color: "#17345f"
    //   }}>{t('liveTracking.title')}</Typography>

    //   {/* Scrollable Table (First Table) */}
    //   <div className="container">
    //     <div
    //       className={
    //         selectedId
    //           ? "first-div first-div-small"
    //           : "first-div first-div-large"
    //       }
    //     >
    //       <form onSubmit={handleSubmit}>
    //         <Grid container spacing={2} className="form-grid-container">
    //           <Grid item className="grid-item">
    //             <Box display="flex" flexDirection="column" gap={1}>
    //               <Box
    //                 display="flex"
    //                 alignItems="center"
    //                 gap={1}
    //               >
    //                 <Box ref={dropdownRef} position="relative" sx={{ width: "300px" }}>
    //                   <TextField
    //                     fullWidth
    //                     label="Vehicle Registration No"
    //                     value={vehicleNo}
    //                     onChange={handleVehicleSearch}
    //                     size="small"
    //                     sx={{
    //                       "& .MuiOutlinedInput-root": {
    //                         borderRadius: "12px"
    //                       }
    //                     }}
    //                   />

    //                   {dropdownOpen && vehicleOptions.length > 0 && (
    //                     <Paper
    //                       elevation={4}
    //                       sx={{
    //                         position: "absolute",
    //                         top: "105%",
    //                         left: 0,
    //                         width: "100%",
    //                         maxHeight: 250,
    //                         overflowY: "auto",
    //                         zIndex: 9999,
    //                         borderRadius: 2,
    //                         boxShadow: "0px 6px 20px rgba(0,0,0,0.15)"
    //                       }}
    //                     >
    //                       {vehicleOptions.map((item, index) => {
    //                         const label =
    //                           typeof item === "string"
    //                             ? item
    //                             : item.vehicle_registration_number || item.regno;

    //                         return (
    //                           <MenuItem
    //                             key={`${label}-${index}`}
    //                             onClick={() => handleSelectVehicle(label)}
    //                             sx={{
    //                               fontSize: "14px",
    //                               padding: "10px 14px",
    //                               borderBottom: "1px solid #f0f0f0",
    //                               "&:hover": {
    //                                 backgroundColor: "#e6f2ff"
    //                               }
    //                             }}
    //                           >
    //                             {label}
    //                           </MenuItem>
    //                         );
    //                       })}
    //                     </Paper>
    //                   )}
    //                 </Box>
    //                 <Tooltip title="Toggle Advanced Filters">
    //                   <IconButton
    //                     onClick={() => setShowFilters(!showFilters)}
    //                     color={showFilters ? "primary" : "default"}
    //                     sx={{ border: '1px solid #ccc', borderRadius: 1 }}
    //                   >
    //                     <FilterListIcon />
    //                   </IconButton>
    //                 </Tooltip>
    //                 <Button
    //                   type="submit"
    //                   variant="contained"
    //                   color="primary"
    //                   sx={{ minWidth: '50px', height: '40px', borderRadius: 1 }}
    //                 >
    //                   <SearchIcon />
    //                 </Button>
    //               </Box>

    //               {/* Collapsible Advanced Filters */}
    //               <Collapse in={showFilters}>
    //                 <Grid container spacing={1} sx={{ mt: 0.5, p: 1, bgcolor: '#f9f9f9', borderRadius: 1, border: '1px solid #eee' }}>
    //                   <Grid item xs={6}>
    //                     <TextField
    //                       fullWidth
    //                       label="Vehicle Owner"
    //                       type="text"
    //                       value={owner}
    //                       name="owner"
    //                       onChange={handleInput}
    //                       variant="outlined"
    //                       size="small"
    //                       InputProps={{ sx: { bgcolor: 'white' } }}
    //                     />
    //                   </Grid>
    //                   <Grid item xs={6}>
    //                     <FormControl fullWidth size="small" sx={{ bgcolor: 'white' }}>
    //                       <InputLabel id="live-tracking-category-label">Category/MaxSpeed</InputLabel>
    //                       <Select
    //                         labelId="live-tracking-category-label"
    //                         label="Category/MaxSpeed"
    //                         value={category}
    //                         name="category"
    //                         onChange={handleInput}
    //                         renderValue={(selected) => {
    //                           if (!selected) return 'All';
    //                           const spd = categorySpeedMap?.[normalizeCategoryKey(selected)] || categoryMaxSpeed;
    //                           if (spd) return `${selected} (${spd} km/h)`;
    //                           return selected;
    //                         }}
    //                       >
    //                         <MenuItem value="">All</MenuItem>
    //                         <MenuItem value="Ambulance">{`Ambulance${categorySpeedMap?.[normalizeCategoryKey('Ambulance')] ? ` (${categorySpeedMap[normalizeCategoryKey('Ambulance')]} km/h)` : ''}`}</MenuItem>
    //                         <MenuItem value="Bus">{`Bus${categorySpeedMap?.[normalizeCategoryKey('Bus')] ? ` (${categorySpeedMap[normalizeCategoryKey('Bus')]} km/h)` : ''}`}</MenuItem>
    //                         <MenuItem value="Dumper">{`Dumper${categorySpeedMap?.[normalizeCategoryKey('Dumper')] ? ` (${categorySpeedMap[normalizeCategoryKey('Dumper')]} km/h)` : ''}`}</MenuItem>
    //                         <MenuItem value="Police">{`Police${categorySpeedMap?.[normalizeCategoryKey('Police')] ? ` (${categorySpeedMap[normalizeCategoryKey('Police')]} km/h)` : ''}`}</MenuItem>
    //                         <MenuItem value="School bus">{`School bus${categorySpeedMap?.[normalizeCategoryKey('School bus')] ? ` (${categorySpeedMap[normalizeCategoryKey('School bus')]} km/h)` : ''}`}</MenuItem>
    //                         <MenuItem value="Tanker">{`Tanker${categorySpeedMap?.[normalizeCategoryKey('Tanker')] ? ` (${categorySpeedMap[normalizeCategoryKey('Tanker')]} km/h)` : ''}`}</MenuItem>
    //                         <MenuItem value="Taxi">{`Taxi${categorySpeedMap?.[normalizeCategoryKey('Taxi')] ? ` (${categorySpeedMap[normalizeCategoryKey('Taxi')]} km/h)` : ''}`}</MenuItem>
    //                         <MenuItem value="Truck">{`Truck${categorySpeedMap?.[normalizeCategoryKey('Truck')] ? ` (${categorySpeedMap[normalizeCategoryKey('Truck')]} km/h)` : ''}`}</MenuItem>
    //                       </Select>
    //                     </FormControl>
    //                   </Grid>
    //                   <Grid item xs={12}>
    //                     <Box display="flex" flexDirection="column" gap={0.5}>
    //                       <Box display="flex" gap={1}>
    //                         <TextField
    //                           fullWidth
    //                           label="POI"
    //                           type="text"
    //                           value={poi}
    //                           name="poi"
    //                           onChange={handleInput}
    //                           variant="outlined"
    //                           size="small"
    //                           InputProps={{ sx: { bgcolor: 'white' } }}
    //                         />
    //                       </Box>
    //                       <Box display="flex" flexWrap="wrap" gap={2}>
    //                         <FormControlLabel
    //                           control={
    //                             <Checkbox
    //                               color="primary"
    //                               checked={inRange}
    //                               onChange={(e) => setInRange(e.target.checked)}
    //                             />
    //                           }
    //                           label="In Range Only"
    //                         />
    //                         <FormControlLabel
    //                           control={
    //                             <Checkbox
    //                               color="primary"
    //                               checked={poiAsPolygon}
    //                               onChange={(e) => setPoiAsPolygon(e.target.checked)}
    //                             />
    //                           }
    //                           label="POI as Polygon"
    //                         />
    //                       </Box>
    //                     </Box>
    //                   </Grid>
    //                   <Grid item xs={6}>
    //                     <TextField
    //                       fullWidth
    //                       label="Roads"
    //                       type="text"
    //                       value={roads}
    //                       name="roads"
    //                       onChange={handleInput}
    //                       variant="outlined"
    //                       size="small"
    //                       InputProps={{ sx: { bgcolor: 'white' } }}
    //                     />
    //                   </Grid>
    //                   <Grid item xs={6}>
    //                     <TextField
    //                       fullWidth
    //                       label="Polygon"
    //                       type="text"
    //                       value={polygon}
    //                       name="polygon"
    //                       onChange={handleInput}
    //                       variant="outlined"
    //                       size="small"
    //                       InputProps={{ sx: { bgcolor: 'white' } }}
    //                     />
    //                   </Grid>
    //                   {userRole === "stateadmin" && (
    //                     <>
    //                       <Grid item xs={6}>
    //                         <TextField
    //                           fullWidth
    //                           label="Make"
    //                           type="text"
    //                           value={make}
    //                           name="make"
    //                           onChange={handleInput}
    //                           variant="outlined"
    //                           size="small"
    //                           InputProps={{ sx: { bgcolor: 'white' } }}
    //                         />
    //                       </Grid>
    //                       <Grid item xs={6}>
    //                         <TextField
    //                           fullWidth
    //                           label="District"
    //                           type="text"
    //                           value={district}
    //                           name="district"
    //                           onChange={handleInput}
    //                           variant="outlined"
    //                           size="small"
    //                           InputProps={{ sx: { bgcolor: 'white' } }}
    //                         />
    //                       </Grid>
    //                     </>
    //                   )}
    //                 </Grid>
    //               </Collapse>
    //             </Box>
    //           </Grid>
    //         </Grid>
    //       </form>
    //       {selectedId && focusedEntry && (
    //         <Paper sx={{ p: 2, mt: 2, }}>
    //           <Typography variant="h6">Vehicle Details</Typography>

    //           <Grid container spacing={1}>
    //             {Object.keys(keyMapping).slice(0, 5).map((key) => (
    //               <React.Fragment key={key}>
    //                 <Grid item xs={5}>
    //                   <Typography fontWeight="bold">
    //                     {keyMapping[key]}
    //                   </Typography>
    //                 </Grid>
    //                 <Grid item xs={7}>
    //                   <Typography>
    //                     {getDisplayCellValue(focusedEntry, key)}
    //                   </Typography>
    //                 </Grid>
    //               </React.Fragment>
    //             ))}
    //           </Grid>
    //           {/*  VIEW MORE BUTTON */}
    //           <Box textAlign="right" mt={2}>
    //             <Button
    //               variant="outlined"
    //               size="small"
    //               onClick={() => setOpenModal(true)}
    //             >
    //               View More
    //             </Button>
    //           </Box>
    //         </Paper>
    //       )}

    //     </div>

    //     {/* HTML Content (iframe) */}
    //     <div className="live-tracking-map-panel" style={{ width: "80%" }}>
    //       {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
    //         <FormControl size="small" sx={{ minWidth: 220 }}>
    //           <InputLabel id="marker-label-mode-label">Marker Label</InputLabel>
    //           <Select
    //             labelId="marker-label-mode-label"
    //             value={markerLabelMode}
    //             label="Marker Label"
    //             onChange={(event) => setMarkerLabelMode(event.target.value)}
    //           >
    //             <MenuItem value="vehicle">Vehicle ID / Registration</MenuItem>
    //             <MenuItem value="block">Block / Area</MenuItem>
    //             <MenuItem value="route">Route Information</MenuItem>
    //           </Select>
    //         </FormControl>
    //       </Box> */}
    //       <Box sx={{
    //         px: 3,
    //         py: 1.8,
    //         borderRadius: "14px 14px 0 0",
    //         display: "flex",
    //         justifyContent: "space-between",
    //         alignItems: "center",
    //         flexWrap: "wrap",
    //         gap: 2,
    //         background: "#17345f",
    //         color: "#fff",
    //       }}>
    //         <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
    //           <Typography fontWeight={700}>
    //             {focusedEntry?.vehicle_registration_number ||
    //               vehicleNo ||
    //               "No Vehicle Selected"}
    //           </Typography>

    //           <Typography sx={{ color: "#ff5252", fontWeight: 700 }}>
    //             ⚡ {focusedEntry?.speed || 0} km/h
    //           </Typography>

    //           <Typography sx={{ color: "#ffffff" }}>
    //             ⏱ {filteredData.length} Vehicle
    //           </Typography>
    //         </Box>


    //         <Box sx={{ display: "flex", gap: 2 }}>
    //           {/* MAP TYPE DROPDOWN */}
    //           <FormControl size="small" sx={{ minWidth: 180 }}>
    //             <Select
    //               value={mapType}
    //               label="Map Type"
    //               onChange={(e) => setMapType(e.target.value)}
    //             >
    //               <MenuItem value="google">Google Map</MenuItem>
    //               <MenuItem value="osm">OpenStreetMap</MenuItem>
    //             </Select>
    //           </FormControl>

    //           {/* EXISTING DROPDOWN */}
    //           <FormControl size="small" sx={{ minWidth: 220 }}>
    //             <Select
    //               labelId="marker-label-mode-label"
    //               value={markerLabelMode}
    //               label="Marker Label"
    //               onChange={(event) => setMarkerLabelMode(event.target.value)}
    //             >
    //               <MenuItem value="vehicle">Vehicle ID / Registration</MenuItem>
    //               <MenuItem value="block">Block / Area</MenuItem>
    //               <MenuItem value="route">Route Information</MenuItem>
    //             </Select>
    //           </FormControl>
    //         </Box>
    //       </Box>
    //       {/* <GoogleMapComponent
    //         gpsData={filteredData}
    //         policeData={policeLocations}
    //         onVehicleClick={handleVehicleMarkerClick}
    //         height={selectedId ? "400px" : "600px"}
    //         focusEntry={focusedEntry}
    //         nmrArea={nmrArea}
    //       /> */}
    //       {mapType === "google" ? (
    //         <GoogleMapComponent
    //           gpsData={filteredData}
    //           policeData={policeLocations}
    //           onVehicleClick={handleVehicleMarkerClick}
    //           height={selectedId ? "400px" : "500px"}
    //           focusEntry={focusedEntry}
    //           nmrArea={nmrArea}
    //         />
    //       ) : (
    //         <OpenStreetMapComponent
    //           gpsData={filteredData}
    //           policeData={policeLocations}
    //           onVehicleClick={handleVehicleMarkerClick}
    //           height={selectedId ? "400px" : "500px"}
    //           focusEntry={focusedEntry}
    //           nmrArea={nmrArea}
    //         />
    //       )}
    //     </div>
    //   </div>
    //   <Dialog
    //     open={openModal}
    //     onClose={() => setOpenModal(false)} //  outside click close
    //     maxWidth="sm"
    //     fullWidth
    //   >
    //     {/* HEADER */}
    //     <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
    //       Vehicle Full Details

    //       <IconButton onClick={() => setOpenModal(false)}>
    //         <CloseIcon />
    //       </IconButton>
    //     </DialogTitle>

    //     {/* CONTENT */}
    //     <DialogContent dividers>
    //       {focusedEntry && (
    //         <Grid container spacing={2}>
    //           {Object.keys(keyMapping).map((key) => (
    //             <React.Fragment key={key}>
    //               <Grid item xs={5}>
    //                 <Typography fontWeight="bold">
    //                   {keyMapping[key]}
    //                 </Typography>
    //               </Grid>
    //               <Grid item xs={7}>
    //                 <Typography>
    //                   {getDisplayCellValue(focusedEntry, key)}
    //                 </Typography>
    //               </Grid>
    //             </React.Fragment>
    //           ))}
    //         </Grid>
    //       )}
    //     </DialogContent>
    //   </Dialog>

    // </MainCard>
  );
};

export default LiveTracking;
